// Single source of truth for public contact + registration details.
// Update here; every page that displays them follows.
// Canonical public origin (no trailing slash, no www).
export const SITE_ORIGIN = "https://raoinvestmentsolution.com";

export const CONTACT = {
  entity: "Rao Enterprises",
  brand: "Rao Investment Solutions",
  arn: "ARN-261755",
  email: "info@raoinvestmentsolution.com",
  phoneDisplay: "+91 75067 84004",
  phoneHref: "tel:+917506784004",
  officeShort: "Mumbai, India",
  hours: "Mon–Sat · 10:00–19:00 IST",
};
